import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactType } from '@modules/contacts/shared/enums/contact-type.enum';
import { Contact } from '@modules/contacts/shared/models/contact.model';
import { phoneCountries } from '@shared/components/phone-input-v2/components/country-picker-v2/phone-countries';

@Component({
  selector: 'app-contact-connection',
  templateUrl: './contact-connection.component.html',
  styleUrls: ['./contact-connection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactConnectionComponent {
  @Input() contact: Contact;

  @Output() onRemove: EventEmitter<void> = new EventEmitter<void>();
  @Output() onEdit: EventEmitter<void> = new EventEmitter<void>();

  protected readonly phoneCountries = phoneCountries;

  get isCompany(): boolean {
    return this.contact.type === ContactType.COMPANY;
  }

  get prefix(): string {
    const country = this.phoneCountries.find((c) => c.flagClass === this.contact.phoneCountry);
    console.log(country);
    return country ? country.dialCode : '';
  }
}
